import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link, graphql } from "gatsby"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Grid, Row, Col } from 'react-bootstrap'

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Korecki Real Estate Services" description="Korecki Real Estate Services provides professional, experienced Strata Management services to clients throughout the Lower Mainland." keywords="korecki,Real Estate,Strata Management services, Strata Property Management, Strata Management, Property Management"/>
    <div>
      <div className="parallax-half-section">
        <LazyLoadImage
          alt="banner"
          height={800}
          style={{objectFit:"cover"}}
          width="100%"
          src={require('../images/seawall_v2.jpg')}
        />
      </div>
      <Grid fluid className="half-section-container">
        <Row>
          <Col md={6} className="half-section">
            <div className="parallax-half-section">
              <LazyLoadImage
                alt="banner"
                height={315}
                style={{objectFit:"cover"}}
                width="100%"
                src={data.contentfulHomePage.strataManagementImage.file.url}
              />
            </div>
          </Col>
          <Col md={6} className="half-section" style={{backgroundColor: '#fafafa'}}>
            <section className="section">
              <div className="col-half-section col-half-section-left">
                <h1 className="text-uppercase font-weight-bold small-h1">Strata Management</h1>
                <p></p>
                {/*<p className="text-md text-color-dark">Meet Porto Finance</p>*/}
                <p className="custom-text-color-1 mb-xlg">
                { data.contentfulHomePage.strataManagement.strataManagement }
                </p>
                <Link to="/strata" className="btn btn-outline btn-primary-1 text-uppercase margin-right margin-bottom" >
                  Read More
                </Link>
                <Link to="/strata/request" className="btn btn-outline btn-primary-1 text-uppercase margin-bottom">
                  Strata Proposal Request
                </Link>
              </div>
            </section>
          </Col>
        </Row>
        <Row className="custom-sm-flex-order">
          <Col md={6} className="half-section" style={{backgroundColor: '#fafafa'}}>
            <section className="section">
              <div className="col-half-section col-half-section-left" id="custom">
                <h1 className="text-uppercase font-weight-bold small-h1">Rental Management</h1>
                <p></p>
                <p className="custom-text-color-1 mb-xlg">
                { data.contentfulHomePage.rentalManagement.rentalManagement }
                </p>
                <Link to="/residential" className="btn btn-outline btn-primary-1 text-uppercase margin-right margin-bottom">
                    Read More
                </Link>
                <Link to="/residential/request" className="btn btn-outline btn-primary-1 text-uppercase margin-bottom">
                    Residential Proposal Request
                </Link>
              </div>
            </section>
          </Col>
          <Col md={6} className="half-section">
            <div className="parallax-half-section">
              <LazyLoadImage
                alt="banner"
                height={315}
                style={{objectFit:"cover"}}
                width="100%"
                src={data.contentfulHomePage.rentalManagementImage.file.url}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="half-section">
            <div className="parallax-half-section">
              <LazyLoadImage
                alt="banner"
                style={{objectFit:"cover"}}
                height={315}
                width="100%"
                src={require('../images/KoreckiImages/forms2.jpg')}
              />
            </div>
          </Col>
          <Col md={6} className="half-section" style={{backgroundColor: '#fafafa'}}>
            <section className="section">
              <div className="col-half-section col-half-section-left">
                <h1 className="text-uppercase font-weight-bold small-h1">Forms</h1>
                <p className="text-md text-color-dark"></p>
                <p className="custom-text-color-1 mb-xlg">
                  { data.contentfulHomePage.forms.forms }
                </p>
                <Link to="/strata/documents" className="btn btn-outline btn-primary-1 text-uppercase">
                    Order Documents
                </Link>
              </div>
            </section>
          </Col>
        </Row>
        <Row className="custom-sm-flex-order">
          <Col md={6} className="half-section" style={{backgroundColor: '#fafafa'}}>
            <section className="section">
              <div className="col-half-section col-half-section-left">
                <h1 className="text-uppercase font-weight-bold small-h1">Careers</h1>
                <p className="text-md text-color-dark"></p>
                <p className="custom-text-color-1 mb-xlg">
                { data.contentfulHomePage.careers.careers }
                </p>
                <Link to="/careers" className="btn btn-outline btn-primary-1 text-uppercase">
                   Apply Now
                </Link>

              </div>
            </section>
          </Col>
          <Col md={6} className="half-section">
            <div className="parallax-half-section">
              <LazyLoadImage
                alt="banner"
                style={{objectFit:"cover"}}
                height={315}
                width="100%"
                src={data.contentfulHomePage.careersImage.file.url}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="half-section">
            <div className="parallax-half-section" style={{objectFit:"cover"}}>
              <LazyLoadImage
                alt="banner"
                height={315}
                width="100%"
                src={data.contentfulHomePage.loginImage.file.url}
              />
            </div>
          </Col>
          <Col md={6} className="half-section" style={{backgroundColor: '#fafafa'}}>
            <section className="section">
              <div className="col-half-section col-half-section-left">
                <h1 className="text-uppercase font-weight-bold small-h1">Client Property Account System</h1>
                <p className="text-md text-color-dark"></p>
                <p className="custom-text-color-1 mb-xlg">
                { data.contentfulHomePage.clientPropertyAccountSystem.clientPropertyAccountSystem }
                  </p>
                <a href = {process.env.GATSBY_API_URL+ "/strataLogin"} className="btn btn-outline btn-primary-1 margin-right text-uppercase">
                   Strata Login
                </a>  
                <a href = {process.env.GATSBY_API_URL+ "/login"} className="btn btn-outline btn-primary-1 text-uppercase">
                   Residential Login
                </a>
              </div>
            </section>
          </Col>
        </Row>
      </Grid>
    </div>
  </Layout>
)

export const query = graphql`
  {
      contentfulHomePage(title: {eq: "Korecki Home Page"}) {
      title
      strataManagement {
        strataManagement
      }
      strataManagementImage {
        file {
          url
        }
      }
      rentalManagement {
        rentalManagement
      }
      rentalManagementImage {
        file {
          url
        }
      }
      forms {
        forms
      }
      formsImage {
        file {
          url
        }
      }
      careers {
        careers
      }
      careersImage {
        file {
          url
        }
      }
      clientPropertyAccountSystem {
        clientPropertyAccountSystem
      }
      loginImage {
        file {
          url
        }
      }
    }
  }`
export default IndexPage
